import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../index.vue'
import Video from '../video.vue'
import zhibo from '../zhibo.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/video',
    name: 'video',
    component: Video
  },
  {
    path: '/zhibo',
    name: 'zhibo',
    component: zhibo
  },
]

const router = new VueRouter({
  mode:'history',
  routes
})

export default router
